import _ from 'lodash';
import { padWithLeadingZeros } from '../../utils';
export function getJsonConfig() {
    return {
        AU: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.STATE',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.SUBURB',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['State', 'Abbr'],
                DIV_2: ['SSC_NAME16'],
            },
        },
        AT: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.STATE',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.DISTRICT',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_1'],
                DIV_2: ['NAME_2', 'Dist-State'],
            },
        },
        CA: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.PROVINCE',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.CENSUS_DIV',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_FR', 'Abbr'],
            },
            NORMALIZER: {
                ZIP: [
                    {
                        funcName: 'castToString',
                    },
                    {
                        funcName: 'substring',
                        options: [0, 3],
                    },
                    {
                        funcName: 'trim',
                    },
                    {
                        funcName: 'toLowerCase',
                    },
                ],
            },
        },
        DK: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.REGION',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.MUNICIPALITY',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_1', 'VARNAME_1'],
                DIV_2: ['NAME_2', 'VARNAME_2'],
            },
            NORMALIZER: {
                ZIP: [
                    {
                        funcName: 'castToString',
                    },
                    {
                        funcName: 'trim',
                    },
                    {
                        funcName: 'toLowerCase',
                    },
                ],
            },
        },
        FR: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.REGION',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.DEPARTMENT',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.ZIP_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_FR'],
                ZIP: [
                    {
                        funcName: 'castToString',
                    },
                    {
                        funcName: 'trim',
                    },
                    {
                        funcName: 'toLowerCase',
                    },
                ],
            },
        },
        DE: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_DE'],
            },
            NORMALIZER: {
                DIV_2: [
                    {
                        funcName: 'toLowerCase',
                    },
                    {
                        funcName: 'replace',
                        options: [/\b(landkreis|eifelkreis)/gi, ''],
                    },
                    {
                        funcName: 'replace',
                        options: [/\s+/g, ' '],
                    },
                    {
                        funcName: 'trim',
                    },
                ],
                ZIP: [
                    {
                        funcName: 'castToString',
                    },
                    {
                        funcName: 'addTrailingZeros',
                        options: [5],
                    },
                ],
            },
        },
        ID: {
            SUPPORT: {
                DIV_1: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.PROVINCE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['Propinsi', 'SUMBER'],
            },
        },
        IN: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.STATE',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.DISTRICT',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['ST_NM', 'ST_ABBR'],
                DIV_2: ['DISTRICT', 'Dist-State'],
            },
        },
        IT: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.REGION',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.PROVINCE',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_1'],
                DIV_2: ['NAME_2', 'Dist-State'],
            },
        },
        JP: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: false,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.PREFECTURE',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.PMC',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['pref'],
                DIV_2: ['pmc'],
            },
        },
        MX: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: false,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.STATE',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.MUNICIPALITY',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_1', 'VARNAME_1', 'Abbr'],
                DIV_2: ['NAME_2', 'VARNAME_2'],
            },
        },
        NL: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.PROVINCE',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.MUNICIPALITY',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_1', 'Abbr', 'VARNAME_1'],
                DIV_2: ['NAME_2', 'Dist-State'],
            },
            NORMALIZER: {
                ZIP: [
                    {
                        funcName: 'castToString',
                    },
                    {
                        funcName: 'substring',
                        options: [0, 4],
                    },
                ],
            },
        },
        NZ: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.REGION',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.DISTRICT',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_1'],
                DIV_2: ['NAME_2', 'Dist-State'],
            },
            NORMALIZER: {
                ZIP: [
                    {
                        funcName: 'addLeadingZeros',
                        options: [4],
                    },
                ],
            },
        },
        NO: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.COUNTY',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.MUNICIPALITY',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_1'],
                DIV_2: ['NAME_2', 'Dist-State'],
            },
            NORMALIZER: {
                ZIP: [
                    {
                        funcName: 'addLeadingZeros',
                        options: [4],
                    },
                ],
            },
        },
        PL: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.PROVINCE',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.COUNTY',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_1'],
                DIV_2: ['NAME_2', 'Dist-State'],
            },
        },
        PT: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.DISTRICT',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.MUNICIPALITY',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_1', 'VARNAME_1'],
                DIV_2: ['NAME_2', 'VARNAME_2'],
            },
        },
        ZA: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
            },
            NORMALIZER: {
                DIV_2: [
                    {
                        funcName: 'toLowerCase',
                    },
                    {
                        funcName: 'replace',
                        options: [
                            /\b(district|metropolitan)?\s*municipality\b/gi,
                            '',
                        ],
                    },
                    {
                        funcName: 'replace',
                        options: [/(\.)/g, ' '],
                    },
                    {
                        funcName: 'replace',
                        options: [/\s+/g, ' '],
                    },
                    {
                        funcName: 'trim',
                    },
                ],
            },
        },
        SE: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.COUNTY',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.MUNICIPALITY',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            NORMALIZER: {
                DIV_1: [
                    {
                        funcName: 'toLowerCase',
                    },
                    {
                        funcName: 'replace',
                        options: [/\bcounty\b/gi, ''],
                    },
                    {
                        funcName: 'replace',
                        options: [/\s+/g, ' '],
                    },
                    {
                        funcName: 'trim',
                    },
                ],
                DIV_2: [
                    {
                        funcName: 'toLowerCase',
                    },
                    {
                        funcName: 'replace',
                        options: [/\bmunicipality\b/gi, ''],
                    },
                    {
                        funcName: 'replace',
                        options: [/\s+/g, ' '],
                    },
                    {
                        funcName: 'trim',
                    },
                ],
                ZIP: [
                    {
                        funcName: 'removeAllWhitespaces',
                    },
                ],
            },
        },
        CH: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.CANTON',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.DISTRICT',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.POSTAL_CODE',
            },
            EXTRA_FIELDS: {
                DIV_1: ['NAME_1'],
                DIV_2: ['NAME_2'],
            },
        },
        GB: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.UK_FIRST_LEVEL',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.UK_SECOND_LEVEL',
                ZIP: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.ZIP_CODE',
            },
            NORMALIZER: {
                DIV_1: [
                    {
                        funcName: 'toLowerCase',
                    },
                    {
                        funcName: 'replace',
                        options: [/\b(greater|the|county(\sof)?)\b/gi, ''],
                    },
                    {
                        funcName: 'replace',
                        options: [/(\,|\.|\-)/g, ' '],
                    },
                    {
                        funcName: 'replace',
                        options: [/\s+/g, ' '],
                    },
                    {
                        funcName: 'trim',
                    },
                ],
                DIV_2: [
                    {
                        funcName: 'toLowerCase',
                    },
                    {
                        funcName: 'replace',
                        options: [/\b(the|county(\sof)?|city(\sof)?)\b/gi, ''],
                    },
                    {
                        funcName: 'replace',
                        options: [/(\,|\.|\-)/g, ' '],
                    },
                    {
                        funcName: 'replace',
                        options: [/\s+/g, ' '],
                    },
                    {
                        funcName: 'trim',
                    },
                ],
                ZIP: [
                    {
                        funcName: 'splitOutcode',
                    },
                ],
            },
        },
        US: {
            SUPPORT: {
                DIV_1: true,
                DIV_2: true,
                ZIP: true,
            },
            LABEL: {
                DIV_1: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.STATE',
                DIV_2: 'metadataExplorer.geoConfigEditor.SUB_DIVISION_NAME.COUNTY',
            },
            EXTRA_FIELDS: {
                DIV_1: ['FIPS'],
                DIV_2: ['FIPS', 'NEW_NAME', 'NEW_FIPS'],
            },
            NORMALIZER: {
                DIV_1: [
                    {
                        funcName: 'padWithLeadingZeros',
                        options: [2],
                    },
                    {
                        funcName: 'trim',
                    },
                    {
                        funcName: 'toLowerCase',
                    },
                ],
                DIV_2: 'CUSTOM_FUNCTION',
                ZIP: [
                    {
                        funcName: 'castToString',
                    },
                    {
                        funcName: 'addTrailingZeros',
                        options: [5],
                    },
                ],
            },
        },
    };
}
const functionMap = {
    removeAllWhitespaces: value => value.replace(/\s+/g, ''),
    splitOutcode: value => value.split(' ', 1),
    replace: (value, regex, replaceValue) => value.replace(new RegExp(regex), replaceValue),
    substring: (value, start, end) => value.substring(start, end),
    trim: value => value.trim(),
    padWithLeadingZeros: (value, options) => /^\d+$/.test(value) ? padWithLeadingZeros(value, options) : value,
    toLowerCase: value => value.toLowerCase(),
    castToString: value => `${value}`,
    addTrailingZeros: value => {
        while (value.length < 5) {
            value = `0${value}`;
        }
        return value;
    },
    addLeadingZeros: (value, options) => {
        while (value.length < options) {
            value = `0${value}`;
        }
        return value;
    },
    CUSTOM_FUNCTION_US_DIV_2: (county) => {
        if (/^\d+$/.test(county)) {
            return padWithLeadingZeros(county, 3);
        }
        county = county.trim().toLowerCase();
        if (new RegExp(`^(baltimore|carson|fairfax|st. louis|richmond|charles|james|
                    bedford|roanoke|franklin)`).test(county)) {
            return county.replace(/\s(county|parish)$/, '');
        }
        return county.replace(/\s(city|county|census\sarea|parish|borough)$/, '');
    },
};
function genericNormalizer(normalizers, regionType, value) {
    let normalizedVal = `${value}`;
    normalizers[regionType].forEach(action => {
        normalizedVal = functionMap[action.funcName].apply(null, [normalizedVal].concat(action.options));
    });
    return normalizedVal;
}
function buildGeoCountryConfig(config) {
    const countries = Object.keys(config);
    const builtConfig = {};
    countries.forEach(countryCode => {
        builtConfig[countryCode] = _.pick(config[countryCode], [
            'SUPPORT',
            'LABEL',
            'EXTRA_FIELDS',
        ]);
        if (config[countryCode].NORMALIZER) {
            builtConfig[countryCode].NORMALIZER = {};
            const normalizers = config[countryCode].NORMALIZER;
            Object.keys(normalizers).forEach(regionType => {
                if (normalizers[regionType] === 'CUSTOM_FUNCTION') {
                    builtConfig[countryCode].NORMALIZER[regionType] =
                        functionMap[`CUSTOM_FUNCTION_${countryCode}_${regionType}`];
                    return;
                }
                builtConfig[countryCode].NORMALIZER[regionType] = genericNormalizer.bind(null, normalizers, regionType);
            });
        }
    });
    return builtConfig;
}
export function getGeoConfig() {
    return buildGeoCountryConfig(getJsonConfig());
}
//# sourceMappingURL=geo-country-config-data.js.map